import template from './ticketStatus.html';

export const ticketStatusComponent = {
  name: 'ticketStatusComponent',
  transclude: true,
  restrict: 'E',
  template,
  controllerAs: 'vm',
  bindings: {
    status: '@',
    title: '@',
    body: '@',
    deadline: '<',
    titleValues: '<',
    bodyValues: '<',
    cta: '&?',
    ctaClass: '@',
    ctaTitle: '@',
    icon: '@',
    transcludeClass: '@'
  }
};
